function Input({className, eyebrow, placeholder, onChange, onKeyUp, type}) {
    return (
        <div className={className ?? ''}>
            <label className="block text-gray-700 text-sm font-bold mb-1">{eyebrow}</label>
            <input onKeyUp={onKeyUp} className="shadow appearance-none border rounded-md w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id={placeholder} type={type} placeholder={placeholder} onChange={onChange} />
        </div>
    )
}

export default Input;